import React, { useState, useRef, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <header className="transparent-header">
      <div className="header-content" ref={menuRef}>
        <div className="company-name">
          <a href="/" onClick={() => setIsMobileMenuOpen(false)}>EchoFrameAI</a>
        </div>
        
        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
        
        {/* Navigation - desktop and mobile */}
        <nav className={`header-nav ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
          <a 
            href="/contact" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="nav-link"
          >
            Contact Us
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;